/**
 * Primer token del nombre completo (saludo shell v3: Header / Dashboard).
 *
 * @param {string|undefined|null} userFullName
 * @returns {string}
 */
export default function firstNameFromFullName(userFullName) {
    if (userFullName == null || typeof userFullName !== "string") {
        return "";
    }
    const trimmed = userFullName.trim();
    if (!trimmed) {
        return "";
    }
    const first = trimmed.split(/\s+/)[0];
    return first || "";
}
